import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import nav from "../config/routes";
import { removeAuthToken } from "../lib/localStorage";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { isEmpty } from "../lib/isEmpty";
import {
  getSiteSettigs,
} from "../actions/settings";
import { API_URL } from "../config";
function Sidebar() {
  const [settingsData, setSettingsData] = useState();

  const history = useHistory();
  const logout = async () => {
    try {
      history.push("/");
      removeAuthToken();
    } catch (err) {
      console.log(err, "err_logout")
    }
  };

  let { restriction } = useSelector((state) => state.isRun);


  useEffect(() => {
    getSettings();
  }, []);

  const getSettings = async () => {
    try {
      let { status, message, result } = await getSiteSettigs();
      setSettingsData(result);
    } catch (err) {
      console.log(err, "errr");
    }
  };

  return (
    <>
      <div className="sidebar d-flex flex-column justify-content-between align-items-start">
        <div className="w-100 sidebar_top">
          <div className="sidebar_logo_holder px-4 py-3 d-flex justify-content-center align-items-center">
            <NavLink to="/dashboard">
              <img
                src={require("../assets/images/logo.png")}
                // src={API_URL + "/public/images/" + settingsData?.sitelogo}
                className="img-fluid main_logo"
              />
            </NavLink>
          </div>
          <ul className="sidebar__scrollUl">
            {nav && nav.length > 0
              ? nav.map((item) => {
                // let Restriction = restriction
                if (
                  restriction?.length > 0 &&
                  restriction?.includes(item.path)
                ) {
                  return (
                    <NavLink
                      to={item.path}
                      className="sidebar_links  rounded-end-5">
                      <li className="rounded-end-5 d-flex gap-3 p-2 ps-4 justify-content-start align-items-center mb-3">

                        <img
                          src={item.image}
                          className="img-fluid sidebar_linkImg"
                        />
                        <p className="sidebar_link_hint">{item.name}</p>
                      </li>
                    </NavLink>
                  );
                } else if (isEmpty(restriction)) {
                  return (
                    <li className="rounded-end-5 mb-3">
                      <NavLink
                        to={item.path}
                        className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                        <img
                          src={item.image}
                          className="img-fluid sidebar_linkImg"
                        />
                        <p className="sidebar_link_hint">{item.name}</p>
                      </NavLink>
                    </li>
                  );
                }
              })
              : ""}
        
            <li className="rounded-end-5 d-flex justify-content-start align-items-center gap-3 p-2 ps-4" onClick={() => logout()}>
          {/* <NavLink className="sidebar_links d-flex gap-3 justify-content-start align-items-center p-2 ps-4"> */}
          <img
            src={require("../assets/images/logout.svg").default}
            className="img-fluid sidebar_linkImg"
          />
          <p className="sidebar_link_hint">Logout</p>
          {/* </NavLink> */}
        </li>
          </ul>
        </div>

        
      </div>
    </>
  );
}

export default Sidebar;
